module.exports = __webpack_public_path__ + "img/edit-icon.26cf9d37.svg";